import { RichText } from 'prismic-reactjs'
import React from 'react'
import { FeatureDescription, FeatureImage, FeatureRowGrid, FeatureTitle } from './style'

const FeatureRow = ({ features, slug, images }: any) => {
  if (!images) return null
  return (
    <>
      {features.map(
        (
          feature: {
            caption: string
            title: string
            description: {
              raw: any
            }
            call_to_action: string
            image: { url: string; alt: string | undefined; img: any }
          },
          index: string | number,
        ) => {
          return (
            <FeatureRowGrid key={index}>
              <FeatureTitle>
                <div>{feature.caption}</div>
                <h3 className={slug}>{feature.title}</h3>
              </FeatureTitle>
              <FeatureDescription>
                <div>{RichText.render(feature.description.raw)}</div>
                <a href="#">{feature.call_to_action}</a>
              </FeatureDescription>
              <FeatureImage>{images[index].img}</FeatureImage>
            </FeatureRowGrid>
          )
        },
      )}
    </>
  )
}

export default FeatureRow
